import React from 'react'
import LoaderImage from '../assets/images/loader.gif'

const Loader = ({loader}) => {
  const containerClass = loader == 'smallScreen' ? 'loader-container-small-screen' : 'loader-container';

  return (
    <>
        <div className= {containerClass}>
           <div className="loader">
              <img src={LoaderImage} className='loaderImage' alt='loader'/>
           </div>
        </div>
    </>
  )
}

export default Loader